import * as yup from 'yup';
import LocalizedStrings from 'localization';

export default yup.object().shape({
  firstName: yup.string().required(LocalizedStrings.firstNameRequired),
  lastName: yup.string().required(LocalizedStrings.lastNameRequired),
});
